import React from "react"
import Cabecalho from "../Cabecalho"
import { FormularioImportacao } from "./components/FormularioImportacao"

export function ImportacaoClientesFornecedor() {
    return (
        <>
            <Cabecalho pagina="Importação de Clientes" />
            <FormularioImportacao />
        </>
    )
}
